module.exports = __webpack_public_path__ + "img/HighHat_Sub.d598adf4.png";